/* eslint-disable */
//   Сервис для создания подписи на клиенте при помощт плагина от Крипто-Про: http://www.cryptopro.ru/products/cades/plugin
//   Подпись создаётся вызовом signData(data, successHandler, errorHandler).
//   Для не-IE браузеров будет показано модлальное окно с выбором сертификатов, в IE отрабатывает нативное.
//
//   data - Base64 encoded данные для подписи, например XML запроса.
//   successHandler - функция срабатывающая на успешной подписи, принимает параметром саму подпись.
//   errorHandler - функция срабатывающая на ошибке, принимает параметром текст ошибки.
//
//   подисывает массив данных,  выбор сертификата происходит только для первого элемента, остальные подписываются уже выбранным.
//   function getSign ( dataArr )
//   возвращает промис, который возвращает массив подписей
//
//   function isPluginInstalled - простая проверка на доступность плагина от Крипто-Про. Возвращает либо true, либо текст
//   ошибки.
//
// import { cadespluginApi } from './cadespluginApi'
import { cadespluginApi } from '@/utils/signature/cadespluginApi.js';
import difference from 'lodash.difference';
import { configSigning } from '@/app.config';
import { Role } from '@/utils/dictionaries';
import { parseDataUserCertificate } from '@/utils/services';

cadespluginApi();

const handleCertINNZeros = (inn) => (inn.startsWith('00') ? inn.slice(2) : inn);

export const signatureService = () => {
  'use strict';

  // cadesplugin, $modal, $q, Session

  var signConfig = {
    PLUGIN_ID: 'cadesplugin',
    CERTIFICATE_STORE_OBJ_NAME: 'CAPICOM.Store',
    SIGNER_OBJ_NAME: 'CAdESCOM.CPSigner',
    SIGNED_DATA_OBJ_NAME: 'CAdESCOM.CadesSignedData',
    CERT_SELECTION_TITLE: 'Выбор сертификата',
    CERT_SELECTION_MESSAGE: 'Пожалуйста, выберите сертификат для подписи',
    CAPICOM_CERT_INFO_SUBJECT_SIMPLE_NAME: 0,
    CAPICOM_CERT_INFO_ISSUER_SIMPLE_NAME: 1,
    CADES_BES: 1,
    CAPICOM_ENCODE_BASE64: 0,
    CAPICOM_CURRENT_USER_STORE: 2,
    CAPICOM_MY_STORE: 'My',
    CAPICOM_STORE_OPEN_READ_ONLY: 0,
    CADESCOM_BASE64_TO_BINARY: 1,
    CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED: 2,
    CAPICOM_CERTIFICATE_FIND_SUBJECT_NAME: 1,
    CAPICOM_CERTIFICATE_FIND_SHA1_HASH: 0,
    opera_crypto_extension_id: 'epebfcehmdedogndhlcacafjaacknbcm',
    opera_crypto_extension_name:
      'CryptoPro Extension for CAdES Browser Plug-in',
    opera_download_chrome_extension_id: 'kipjbhgniklcnglfaldilecjomjaddfi',
    opera_download_chrome_extension_name: 'Download Chrome Extension',
    chrome_crypto_extension_id: 'iifchhfnnmpdbibifmljnfjhpififfog',
  };
  var _error = null; // ошибка загрузки или null, если все ок
  var link =
    'http://www.cryptopro.ru/sites/default/files/products/cades/demopage/main.html'; // эта страница с загрузкой и инструкцией // "http://www.cryptopro.ru/products/cades/plugin"
  var _loadMsg =
    'Вам необходимо установить КриптоПро ЭЦП Browser plug-in для подписи. Инструкции по ссылке: <a href="' +
    link +
    '" target="_blank">' +
    link +
    '</a>';

  var _certs = null; // массив с сертификатами

  // инициализация для ФФ
  if (cadesplugin.my_init) {
    cadesplugin.my_init();
  }
  // получение ошибки
  if (cadesplugin.then) {
    cadesplugin
      .then(function () {
        _error = null;
      })
      .catch(function (res) {
        _error = res;
      });
  } else {
    if (cadesplugin._myPostMessageError) {
      _error = cadesplugin._myPostMessageError;
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  function getInstalledCertificatesSync() {
    var i;
    if (_certs === null || _certs.length === 0) {
      try {
        _certs = [];
        var oStore = cadesplugin.CreateObject(
          signConfig.CERTIFICATE_STORE_OBJ_NAME
        );
        oStore.Open(
          signConfig.CAPICOM_CURRENT_USER_STORE,
          signConfig.CAPICOM_MY_STORE,
          signConfig.CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED
        );

        var certsCount = oStore.Certificates.Count;
        if (certsCount == 0) {
          //   console.log("Нет доступных сертификатов");
          throw new Error('Нет доступных сертификатов');
        }

        var cert;
        for (i = 0; i < certsCount; i++) {
          cert = oStore.Certificates.Item(i + 1);

          // собираем oid
          var oids = [];
          var ekusCount = cert.ExtendedKeyUsage().EKUs.Count;
          var ekus = cert.ExtendedKeyUsage().EKUs;
          for (var j = 1; j <= ekusCount; j++) {
            oids.push(ekus.Item(j).OID);
          }

          _certs.push({
            id: i,
            subjectSimpleName: cert.GetInfo(
              signConfig.CAPICOM_CERT_INFO_SUBJECT_SIMPLE_NAME
            ),
            issuerSimpleName: cert.GetInfo(
              signConfig.CAPICOM_CERT_INFO_ISSUER_SIMPLE_NAME
            ),
            subjectDescription: cert.SubjectName,
            issuerDescription: cert.IssuerName,
            validFrom: cert.ValidFromDate,
            validTo: cert.ValidToDate,
            thumbprint: cert.Thumbprint,
            origin: cert,
            oid: oids,
          });
        }
        oStore.Close();
      } catch (e) {
        throw new Error(e);
      }
    }
    return Promise.resolve(_certs);
  }

  function getInstalledCertificatesAsync() {
    if (_certs && _certs.length > 0) {
      return Promise.resolve(_certs);
    } else {
      return new Promise(function (resolve, reject) {
        cadesplugin.async_spawn(
          function* (args) {
            try {
              var certStore = yield cadesplugin.CreateObjectAsync(
                signConfig.CERTIFICATE_STORE_OBJ_NAME
              );

              if (!certStore) {
                //   console.log("certStore failed");
                throw new Error('certStore failed');
              }

              yield certStore.Open(
                signConfig.CAPICOM_CURRENT_USER_STORE,
                signConfig.CAPICOM_MY_STORE,
                signConfig.CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED
              );

              var certs = yield certStore.Certificates;
              var certCnt = yield certs.Count;

              if (certCnt == 0) {
                certStore.Close();
                //   console.log('Нет доступных сертификатов');
                throw new Error('Нет доступных сертификатов');
              }
              _certs = [];

              for (var i = 0; i < certCnt; i++) {
                var certItem = yield certs.Item(i + 1);

                var Validator = yield certItem.IsValid();
                var IsValid = yield Validator.Result;
                let HasPrivateKey = yield certItem.HasPrivateKey();

                //TODO: uncomment if we need only vaild certificate
                /*if (currentDate < ValidToDate && HasPrivateKey && IsValid) {*/
                var cert = { id: i };
                cert['subjectSimpleName'] = yield certItem.GetInfo(
                  signConfig.CAPICOM_CERT_INFO_SUBJECT_SIMPLE_NAME
                );
                cert['issuerSimpleName'] = yield certItem.GetInfo(
                  signConfig.CAPICOM_CERT_INFO_ISSUER_SIMPLE_NAME
                );
                cert['subjectDescription'] = yield certItem.SubjectName;
                cert['issuerDescription'] = yield certItem.IssuerName;
                cert['validFrom'] = yield certItem.ValidFromDate;
                cert['validTo'] = yield certItem.ValidToDate;
                cert['thumbprint'] = yield certItem.Thumbprint;
                cert['isValid'] = IsValid;
                cert['origin'] = certItem;
                cert['oid'] = [];

                // Проверка закрытого ключа, убрать если будем выводить только актуальные серитификаты
                if (HasPrivateKey) {
                  cert['PrivateKey'] = yield certItem.PrivateKey;
                }

                var getExtendedKeyUsage = yield certItem.ExtendedKeyUsage();
                var ekus = yield getExtendedKeyUsage.EKUs;
                var ekusCount = yield ekus.Count;
                // Собираем OID
                for (var j = 1; j <= ekusCount; j++) {
                  var ekus_item = yield ekus.Item(j);
                  cert['oid'].push(yield ekus_item.OID);
                }
                _certs.push(cert);
              }
              certStore.Close();
              args[0](_certs);
            } catch (ex) {
              //   console.log(ex);
              args[1](new Error('Ошибка: ' + getErrorMessage(ex)));
            }
          },
          resolve,
          reject
        );
      });
    }
  }

  function signCreateSync(cert, dataToSign) {
    var oSigner = cadesplugin.CreateObject(signConfig.SIGNER_OBJ_NAME);
    oSigner.Certificate = cert;
    var oSignedData = cadesplugin.CreateObject(signConfig.SIGNED_DATA_OBJ_NAME);

    if (dataToSign) {
      oSignedData.ContentEncoding = cadesplugin.CADESCOM_BASE64_TO_BINARY; //  1; //CADESCOM_BASE64_TO_BINARY
      oSignedData.Content = dataToSign;
      return oSignedData.SignCades(
        oSigner,
        cadesplugin.CADESCOM_CADES_BES,
        true
      );
    }
  }

  function SignCreateAsync(cert, dataToSign) {
    return new Promise(function (resolve, reject) {
      cadesplugin.async_spawn(
        function* (args) {
          var Signature;
          try {
            var errormes = '';
            try {
              var oSigner = yield cadesplugin.CreateObjectAsync(
                signConfig.SIGNER_OBJ_NAME
              );
            } catch (err) {
              errormes =
                'Failed to create ' +
                signConfig.SIGNER_OBJ_NAME +
                ': ' +
                err.number;
              //   console.log(errormes);
              throw new Error(errormes);
            }

            if (oSigner) {
              yield oSigner.propset_Certificate(cert);
            } else {
              errormes = 'Failed to create ' + signConfig.SIGNER_OBJ_NAME;
              //   console.log(errormes);
              throw new Error(errormes);
            }

            var oSignedData = yield cadesplugin.CreateObjectAsync(
              signConfig.SIGNED_DATA_OBJ_NAME
            );

            if (dataToSign) {
              // Данные на подпись ввели
              yield oSignedData.propset_ContentEncoding(
                signConfig.CADESCOM_BASE64_TO_BINARY
              );
              yield oSignedData.propset_Content(dataToSign);
              try {
                Signature = yield oSignedData.SignCades(
                  oSigner,
                  signConfig.CADES_BES,
                  true
                );
              } catch (err) {
                errormes =
                  'Не удалось создать подпись из-за ошибки: ' +
                  getErrorMessage(err);
                //   console.log(errormes);
                throw new Error(errormes);
              }
            }
            args[2](Signature);
          } catch (err) {
            //   console.log(err);
            args[3](err ? err : 'Возникла непредвиденная ошибка');
          }
        },
        cert,
        dataToSign,
        resolve,
        reject
      );
    });
  }

  function getInstalledCertificates() {
    if (!!cadesplugin.CreateObjectAsync) {
      return getInstalledCertificatesAsync();
    } else {
      return getInstalledCertificatesSync();
    }
  }

  function signCreate(certificate, dataToSign) {
    if (!!cadesplugin.CreateObjectAsync) {
      return SignCreateAsync(certificate, dataToSign);
    } else {
      return Promise.resolve(signCreateSync(certificate, dataToSign));
    }
  }

  function _convertCertDescriptionToObject(description) {
    if (!description) return;
    let result = {},
      key,
      value;
    description
      .match(
        /(G|CN|SN|ИНН|INN|INNLE|1\.2\.643\.100\.4|ОГРН|OGRN|ОГРНИП|OGRNIP|СНИЛС|ИНН организации|ИНН ЮЛ)\s?=\s?(("[\s«»'"0-9a-zA-Zа-яА-ЯЁё,-]*")|([«»'"0-9a-zA-Zа-яА-ЯЁё-]+\s?([\s«»'"0-9a-zA-Zа-яА-ЯЁё-]*)+))/g
      )
      .forEach((item) => {
        [key, value] = item.split(/\s?=\s?/);
        // если "ИНН организации" или "ИНН ЮЛ" заменяем на "INNLE"
        if (/ИНН /i.test(key)) key = 'INNLE';
        // OID 1.2.643.100.4 - это INNLE
        if (/1\.2\.643\.100\.4/i.test(key)) key = 'INNLE';

        result[key] = value;
      });
    return result;
  }

  function getErrorMessage(e) {
    var err = e.message;
    if (!err) {
      err = e;
    } else if (e.number) {
      err += ' (0x' + this.decimalToHexString(e.number) + ')';
    }
    return err;
  }

  function checkNameOrg({ user, subjectDescription }) {
    let check = false;

    let subjectNAME =
      subjectDescription['CN'] && subjectDescription['CN'].toUpperCase();
    let userNAME = (user.name && user.name.toUpperCase()) || null;

    if (!userNAME || subjectNAME !== userNAME) {
      check = true;
    }

    return check;
  }

  function toSubjectFIO(name, joinSeparator) {
    const matchesName = name.toUpperCase().match(/[А-ЯЁ.-]+/g);

    return matchesName && matchesName.join(joinSeparator);
  }

  function checkFIO({ user, subjectDescription }) {
    console.group();
    console.log('--- checkFIO');
    console.log('--- user', JSON.stringify(user));
    console.log('--- subjectDescription', JSON.stringify(subjectDescription));
    console.groupEnd();

    let check = false;

    const joinSeperator = ' ';
    const subjectFIO = [
      toSubjectFIO(subjectDescription['SN'], joinSeperator),
      toSubjectFIO(subjectDescription['G'], joinSeperator),
    ];
    const userG = [
      user.userFirstName.toUpperCase(),
      user.userMiddleName ? user.userMiddleName.toUpperCase() : null,
    ]
      .filter(Boolean)
      .join(joinSeperator);
    const userFIO = [user.userLastName.toUpperCase(), userG];

    if (
      !subjectDescription['G'] ||
      difference(subjectFIO, userFIO).length > 0
    ) {
      check = true;
    }

    return check;
  }

  function checkSNILS({ user, cert }) {
    let check = false;
    // проверка СНИЛС: проверяется сразу внутри текстового описания сертификата, потому что СНИЛС может задаваться и произвольным именем, наподобие "1.2.643.3.131.1.1". Тоже самое с ОГРН и ИНН
    var userSnils = user.snils.match(/\d/g).join('');
    if (!userSnils || !cert['subjectDescription'].includes(userSnils)) {
      check = true;
    }
    return check;
  }

  function checkINN({ user, subjectDescription, cert }) {
    let check = false;

    // вначале выбираем INNLE для организации, если он там есть. Если нет, уже другие ИНН
    // для физика INNLE нет и всегда будет пропускать
    let INN =
      subjectDescription['INNLE'] ||
      subjectDescription['ИНН'] ||
      subjectDescription['INN'];

    if (INN && user.inn !== handleCertINNZeros(INN)) {
      check = true;
    } else {
      // проверка ИНН: проверяется сразу внутри текстового описания сертификата, потому что ИНН может задаваться и произвольным именем, наподобие "1.2.643.3.131.1.1".
      var userINN = user.inn.match(/\d/g).join('');

      if (
        !userINN ||
        !(
          cert['subjectDescription'].includes(userINN) ||
          cert['subjectDescription'].includes(`00${userINN}`)
        )
      ) {
        check = true;
      }
    }
    return check;
  }

  function checkOGRN({ user, subjectDescription, cert }) {
    let check = false;

    let OGRN = subjectDescription['ОГРН'] || subjectDescription['OGRN'];
    if (OGRN) {
      if (!OGRN || Number(user.ogrn) != OGRN) {
        check = true;
      }
    } else {
      // проверка ОГРН: проверяется сразу внутри текстового описания сертификата, потому что ОГРН может задаваться и произвольным именем, наподобие "1.2.643.3.131.1.1".
      var userOGRN = user.ogrn.match(/\d/g).join('');
      if (!userOGRN || !cert['subjectDescription'].includes(userOGRN)) {
        check = true;
      }
    }

    return check;
  }

  function checkOGRNIP({ user, subjectDescription, cert }) {
    let check = false;

    let OGRN = subjectDescription['ОГРНИП'] || subjectDescription['OGRNIP'];
    if (OGRN) {
      if (!OGRN || Number(user.ogrn) != OGRN) {
        check = true;
      }
    } else {
      // проверка ОГРНИП: проверяется сразу внутри текстового описания сертификата, потому что ОГРНИП может задаваться и произвольным именем, наподобие "1.2.643.3.131.1.1".
      var userOGRN = user.ogrn.match(/\d/g).join('');
      if (!userOGRN || !cert['subjectDescription'].includes(userOGRN)) {
        check = true;
      }
    }

    return check;
  }

  function _isInvalidCertificate(cert, user) {
    var errorChecks = [],
      subjectDescription = _convertCertDescriptionToObject(
        cert['subjectDescription']
      );
    const signerType = subjectDescription['INNLE']
      ? Role.ORGANIZATION
      : Role.PERSON;
    const checkedUser = parseDataUserCertificate(user, signerType);

    // проверка ФИО
    if (checkFIO({ user: checkedUser, subjectDescription })) {
      errorChecks.push('ФИО');
    }

    // проверка СНИЛС
    if (checkSNILS({ user: checkedUser, subjectDescription, cert })) {
      errorChecks.push('СНИЛС');
    }

    // проверка соответствия ИНН
    if (checkINN({ user: checkedUser, subjectDescription, cert })) {
      errorChecks.push('ИНН');
    }

    if (
      checkedUser.subjectType === Role.PERSON &&
      checkedUser.isBusinessman &&
      checkedUser.ogrn
    ) {
      // проверка соответствия ОГРНИП, только для ИП
      // у ИП с представителем нет проверки ОГРНИП, ogrn - не передается
      if (checkOGRNIP({ user: checkedUser, subjectDescription, cert })) {
        errorChecks.push('ОГРНИП');
      }
    }

    if (checkedUser.subjectType === Role.ORGANIZATION && checkedUser.ogrn) {
      // проверка соответствия ОГРН
      if (checkOGRN({ user: checkedUser, subjectDescription, cert })) {
        errorChecks.push('ОГРН');
      }
    }

    // проверка на совпадение параметров
    if (errorChecks.length > 0) {
      return errorChecks;
    }
    return false;
  }

  var resultService = {
    signData: function () {
      var certs = [];

      if (this.isErrorPlugin()) {
        return new Promise((resolve) => {
          resolve({ dialogPlagin: true });
        });
      }

      return getInstalledCertificates().then(function (_certs) {
        certs = _certs;
        if (certs.length === 0) {
          throw 'У Вас нет сертификатов для подписи';
        }

        // Возвращаем список сертификатов, для модалки vue
        return certs;
      });
    },
    startSigning: function (cert, user, fileBase) {
      try {
        // получаем из модалки
        // cert - сертификат выбранный
        // user - данные пользователя для сравнения с сертификатом
        if (!cert) return;

        // Проверка срока
        if (cert.validTo < new Date()) {
          throw {
            message: `Выбранный сертификат просрочен (срок действия до ${cert.validToText}). Подписание невозможно.`,
          };
        }

        if (user && typeof user === 'object' && configSigning) {
          var errorChecks = _isInvalidCertificate(cert, user);
          if (errorChecks && errorChecks.length > 0) {
            throw {
              message:
                'Подписание невозможно. Используйте сертификат пользователя, под учетной записью которого осуществлен вход в Личный кабинет. Не совпадает: ' +
                errorChecks.join(', '),
            };
          }
        }

        var promises = [],
          signs = fileBase;

        for (var prop in signs) {
          promises.push(signCreate(cert.origin, signs[prop]));
        }

        return Promise.all(promises).then(function (result) {
          let arr = [];
          arr.push(result);
          return { success: true, arrSign: arr };
        });
      } catch (error) {
        throw new Error(error.message);
      }
    },
    getSign: function (dataArr) {
      if (!dataArr || dataArr.length === 0) {
        return new Promise((resolve) => {
          resolve({ error: 'Пустой список для подписи' });
        });
      } else {
        return this.signData(dataArr);
      }
    },
    isErrorPlugin: function () {
      return _error !== null;
    },
    isPluginInstalled: function () {
      // Проверка на доступность плагина
      if (!cadesplugin.then) throw { message: _loadMsg };
      return cadesplugin
        .then(function () {
          return true;
        })
        .catch(function () {
          throw { message: _loadMsg };
        });
    },
    getCertificates: getInstalledCertificates,
    _convertCertDescriptionToObject: _convertCertDescriptionToObject,
    _isInvalidCertificate: _isInvalidCertificate,
  };

  return resultService;
};
